(function () {
	const isMobile = () => window.matchMedia("(max-width: 749px)").matches;

	const setupDesktopHeights = (tabSection) => {
		const tabContents = tabSection.querySelectorAll("[data-tab-content]");
		let maxContentHeight = 0;

		tabContents.forEach((tabContent) => {
			const originalDisplay = tabContent.style.display;
			tabContent.style.display = "block";
			const tabItemInfoBlock = tabContent.querySelector(
				".testimonials__item-block"
			);
			if (tabItemInfoBlock && tabItemInfoBlock.clientHeight > maxContentHeight) {
				maxContentHeight = tabItemInfoBlock.clientHeight;
			}
			tabContent.style.display = originalDisplay;
		});

		tabContents.forEach((tabContent) => {
			const tabItemInfoBlock = tabContent.querySelector(
				".testimonials__item-block"
			);
			if (tabItemInfoBlock) {
				tabItemInfoBlock.style.minHeight = maxContentHeight + "px";
			}
		});
	};

	const activateIndex = (tabSection, index) => {
		const tabs = tabSection.querySelectorAll("[data-tab-target]");
		const tabContents = tabSection.querySelectorAll("[data-tab-content]");
		tabs.forEach((t, i) => t.classList.toggle("active", i === index));
		tabContents.forEach((c, i) => c.classList.toggle("active", i === index));

		const tabsList = tabSection.querySelector(".testimonials-tabs-list");
		const activeTab = tabs[index];
		if (tabsList && activeTab && tabsList.scrollWidth > tabsList.clientWidth) {
			const targetLeft =
				activeTab.offsetLeft -
				tabsList.offsetLeft -
				(tabsList.clientWidth - activeTab.clientWidth) / 2;
			tabsList.scrollTo({
				left: Math.max(0, targetLeft),
				behavior: "smooth",
			});
		}
	};

	const setupMobileSwipe = (tabSection) => {
		const block = tabSection.querySelector(".testimonials__block");
		const tabs = tabSection.querySelectorAll("[data-tab-target]");
		const tabContents = tabSection.querySelectorAll("[data-tab-content]");
		if (!block || !tabContents.length) return;

		tabContents.forEach((c) => {
			const infoBlock = c.querySelector(".testimonials__item-block");
			if (infoBlock) infoBlock.style.minHeight = "";
		});

		const scrollToIndex = (index) => {
			const target = tabContents[index];
			if (!target) return;
			block.scrollTo({
				left: target.offsetLeft - block.offsetLeft,
				behavior: "smooth",
			});
		};

		tabs.forEach((tab, i) => {
			tab.__mobileHandler = (e) => {
				e.preventDefault();
				activateIndex(tabSection, i);
				scrollToIndex(i);
			};
			tab.addEventListener("click", tab.__mobileHandler);
		});

		let rafId = null;
		const onScroll = () => {
			if (rafId) return;
			rafId = window.requestAnimationFrame(() => {
				rafId = null;
				const center = block.scrollLeft + block.clientWidth / 2;
				let closestIndex = 0;
				let closestDistance = Infinity;
				tabContents.forEach((content, i) => {
					const contentCenter =
						content.offsetLeft - block.offsetLeft + content.clientWidth / 2;
					const distance = Math.abs(contentCenter - center);
					if (distance < closestDistance) {
						closestDistance = distance;
						closestIndex = i;
					}
				});
				activateIndex(tabSection, closestIndex);
			});
		};
		block.__mobileScrollHandler = onScroll;
		block.addEventListener("scroll", onScroll, { passive: true });

		requestAnimationFrame(() => {
			const activeIndex = Array.from(tabContents).findIndex((c) =>
				c.classList.contains("active")
			);
			if (activeIndex > 0) scrollToIndex(activeIndex);
		});
	};

	const teardownMobileSwipe = (tabSection) => {
		const block = tabSection.querySelector(".testimonials__block");
		const tabs = tabSection.querySelectorAll("[data-tab-target]");
		if (block && block.__mobileScrollHandler) {
			block.removeEventListener("scroll", block.__mobileScrollHandler);
			delete block.__mobileScrollHandler;
		}
		tabs.forEach((tab) => {
			if (tab.__mobileHandler) {
				tab.removeEventListener("click", tab.__mobileHandler);
				delete tab.__mobileHandler;
			}
		});
	};

	const setupDesktopTabs = (tabSection) => {
		const tabs = tabSection.querySelectorAll("[data-tab-target]");
		const tabContents = tabSection.querySelectorAll("[data-tab-content]");
		tabs.forEach((tab) => {
			tab.__desktopHandler = () => {
				tabContents.forEach((c) => c.classList.remove("active"));
				tabs.forEach((t) => t.classList.remove("active"));
				tab.classList.add("active");
				const targets = tabSection.querySelectorAll(
					`[data-tab-content="${tab.dataset.tabTarget}"]`
				);
				targets.forEach((target) => target.classList.add("active"));
			};
			tab.addEventListener("click", tab.__desktopHandler);
		});
	};

	const teardownDesktopTabs = (tabSection) => {
		const tabs = tabSection.querySelectorAll("[data-tab-target]");
		tabs.forEach((tab) => {
			if (tab.__desktopHandler) {
				tab.removeEventListener("click", tab.__desktopHandler);
				delete tab.__desktopHandler;
			}
		});
	};

	const applyMode = (tabSection) => {
		teardownDesktopTabs(tabSection);
		teardownMobileSwipe(tabSection);
		if (isMobile()) {
			setupMobileSwipe(tabSection);
		} else {
			setupDesktopHeights(tabSection);
			setupDesktopTabs(tabSection);
		}
	};

	const sectionTabs = () => {
		const tabsSections = document.querySelectorAll(".testimonials");
		tabsSections.forEach((tabSection) => {
			applyMode(tabSection);

			if (!tabSection.__resizeBound) {
				tabSection.__resizeBound = true;
				let resizeTimer;
				window.addEventListener("resize", () => {
					clearTimeout(resizeTimer);
					resizeTimer = setTimeout(() => applyMode(tabSection), 150);
				});
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		sectionTabs();
		document.addEventListener("shopify:section:load", function () {
			sectionTabs();
		});
	});
})();
